import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Select } from 'components/forms'
import NewCategoryForm from './new-category-form'

const NEW_CATEGORY = 'new-category'

export default class CategorySelector extends Component {
  static propTypes = {
    categories: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        position: PropTypes.number,
      })
    ),
    onCategoryChange: PropTypes.func.isRequired,
    onCategoryAdd: PropTypes.func,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }

  static defaultProps = {
    label: 'Category',
  }

  constructor(props) {
    super(props)

    this.state = {
      value: props.value,
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ value: nextProps.value })
  }

  handleChange = ({ target: { value } }) => {
    this.setState({ showNewCategoryForm: value === NEW_CATEGORY, value })

    if (value === NEW_CATEGORY) {
      this.props.onCategoryChange({ [this.props.name]: null })
    } else {
      this.props.onCategoryChange({ [this.props.name]: value })
    }
  }

  render() {
    const { categories, groupClassName, onCategoryAdd, name, label } =
      this.props

    return (
      <React.Fragment>
        <Select
          label={label}
          value={this.state.value}
          name={name}
          onChange={this.handleChange}
          wrapperClassName={groupClassName}
        >
          {onCategoryAdd ? (
            <option value={NEW_CATEGORY}>+ New Category</option>
          ) : null}

          {categories
            .map((category) => (
              <option key={category.id} value={category.id}>
                {category.title}
              </option>
            ))
            .sort((a, b) => a.position - b.position)}
        </Select>

        {this.state.showNewCategoryForm && onCategoryAdd ? (
          <NewCategoryForm onChange={onCategoryAdd} />
        ) : null}
      </React.Fragment>
    )
  }
}
